module.exports = __webpack_public_path__ + "3935f3f68d015a81cec86b2c7da4921c.woff2";